import {SimplexClassic as BaseSimplex} from 'services/sports/mlb/simplex/simplex-classic';
import Const from 'constants';
import Action from 'actions';
import {isPlayerOnDoublePosition} from 'helpers/player-helper';
import {getSimplexUnitName} from 'helpers/simplex-helper';
import RuleBuilder from 'services/simplex/rule-builder';

export default class SimplexClassic extends BaseSimplex {
    positions({incomingValues = {}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const playersGroupedByPositions = preparedPlayers.groupedBy.property('positionName');
        const configPositions = sportConfig.getConfigProp('positions');
        const simplexUnitsByPositionsMatrix = {};

        Object.values(configPositions).map((position) => {
            Object.keys(playersGroupedByPositions).map((positionName) => {
                const positions = position.allowedPositions.map((key) => configPositions[key].shortName);
                const duplicates = arrayDuplicates(positions, positionName.split('/'));

                if (isEmpty(duplicates)) {
                    return;
                }

                simplexUnitsByPositionsMatrix[position.shortName] ??= {};
                simplexUnitsByPositionsMatrix[position.shortName][positionName] ??= {};

                playersGroupedByPositions[positionName].map((player) => {
                    simplexUnitsByPositionsMatrix[position.shortName][positionName][
                        getSimplexUnitName(player.getId())
                    ] = 1;
                });
            });
        });

        const simplexUnitsGroupedByPositions = {};
        Object.values(simplexUnitsByPositionsMatrix).map((positions) => {
            Object.keys(positions).map((positionName) => {
                simplexUnitsGroupedByPositions[positionName] = {...positions[positionName]};
            });
        });

        const getRuleForMinUnitsQuantity = function (keyPositionName, simplexUnitsByPositionsMatrix) {
            const result = [];

            const simplexUnitsByPositionMatrix = simplexUnitsByPositionsMatrix[keyPositionName];
            const positionConfig = sportConfig.getPositionByName(keyPositionName, {});

            if (isEmpty(positionConfig)) {
                return result;
            }

            let simplexUnits = {};
            Object.values(simplexUnitsByPositionMatrix).map((positionSimplexUnits) => {
                simplexUnits = {...simplexUnits, ...positionSimplexUnits};
            });

            if (isEmpty(simplexUnits)) {
                return result;
            }

            const keyPositionRule = RuleBuilder.fromAtLeast(positionConfig.minPlayers, {...simplexUnits}).createRule();

            result.push(keyPositionRule);

            Object.keys(simplexUnitsByPositionMatrix).map((subPositionName) => {
                if (keyPositionName === subPositionName) {
                    return;
                }

                subPositionName.split('/').map((positionName) => {
                    if (keyPositionName === positionName) {
                        return;
                    }

                    let simplexUnits = {};
                    Object.values(simplexUnitsByPositionsMatrix[positionName]).map((positionSimplexUnits) => {
                        simplexUnits = {...simplexUnits, ...positionSimplexUnits};
                    });

                    if (!isEmpty(simplexUnits)) {
                        const {minPlayers = 0} = sportConfig.getPositionByName(positionName, {});

                        const ruleBuilder = RuleBuilder.fromAtLeast(minPlayers + keyPositionRule.obj).addVars({
                            ...simplexUnits,
                            ...keyPositionRule.row,
                        });

                        result.push(ruleBuilder.createRule());
                    }
                });
            });

            {
                const usedPositionNames = [];
                let simplexUnits = {},
                    minQuantity = 0;
                Object.keys(simplexUnitsByPositionMatrix).map((subPositionName) => {
                    subPositionName.split('/').map((positionName) => {
                        if (inArray(positionName, usedPositionNames)) {
                            return;
                        }

                        usedPositionNames.push(positionName);
                        const {minPlayers = 0} = sportConfig.getPositionByName(positionName, {});
                        minQuantity += minPlayers;
                        Object.values(simplexUnitsByPositionsMatrix[positionName]).map((positionSimplexUnits) => {
                            simplexUnits = {...simplexUnits, ...positionSimplexUnits};
                        });
                    });
                });

                const ruleBuilder = RuleBuilder.fromAtLeast(minQuantity, {...simplexUnits});
                result.push(ruleBuilder.createRule());
            }

            return result;
        };

        const getRuleForMaxUnitsQuantity = function (keyPositionName, simplexUnitsByPositionsMatrix) {
            const result = [];

            const simplexUnitsByPositionMatrix = simplexUnitsByPositionsMatrix[keyPositionName];
            const positionNamesUsageMap = {};
            let simplexUnits = {};

            Object.keys(simplexUnitsByPositionMatrix).map((subPositionName) => {
                const positionNames = subPositionName.split('/');
                let positionSimplexUnits = {...simplexUnitsByPositionMatrix[subPositionName]};
                let playersQuantity = 0;

                simplexUnits = {...simplexUnits, ...positionSimplexUnits};
                positionNames.map((key) => (positionNamesUsageMap[key] = 1));

                Object.values(sportConfig.getConfigProp('positions')).map((positionConfig) => {
                    const {shortName} = positionConfig;

                    if (!inArray(shortName, positionNames)) {
                        return;
                    }

                    playersQuantity += positionConfig.minPlayers;

                    shortName in simplexUnitsByPositionsMatrix[shortName] &&
                        (positionSimplexUnits = {
                            ...positionSimplexUnits,
                            ...simplexUnitsByPositionsMatrix[shortName][shortName],
                        });
                });

                if (0 < playersQuantity) {
                    const ruleBuilder = RuleBuilder.fromAtMost(playersQuantity, {...positionSimplexUnits});
                    result.push(ruleBuilder.createRule());
                }
            });

            let totalPlayersQuantity = 0;
            Object.keys(positionNamesUsageMap).map((positionName) => {
                const positionConfig = sportConfig.getPositionByName(positionName, {});
                totalPlayersQuantity += positionConfig.minPlayers;
                positionName in simplexUnitsByPositionsMatrix[positionName] &&
                    (simplexUnits = {
                        ...simplexUnits,
                        ...simplexUnitsByPositionsMatrix[positionName][positionName],
                    });
            });

            if (0 < totalPlayersQuantity) {
                const ruleBuilder = RuleBuilder.fromAtMost(totalPlayersQuantity, {...simplexUnits});
                result.push(ruleBuilder.createRule());
            }

            return [...result];
        };

        const getRuleForMaxMixedUnitsQuantity = function (keyPositionName, simplexUnitsByPositionsMatrix) {
            const result = [];

            const simplexUnitsByPositionMatrix = simplexUnitsByPositionsMatrix[keyPositionName];
            const positionLimits = {};
            let usedPositionNames = [];

            Object.keys(simplexUnitsByPositionMatrix).map((subPositionName) => {
                const positionNames = subPositionName.split('/');
                usedPositionNames = [...usedPositionNames, ...positionNames];
                Object.values(sportConfig.getConfigProp('positions')).map((positionConfig) => {
                    const {shortName} = positionConfig;
                    if (inArray(shortName, positionNames)) {
                        positionLimits[shortName] = positionConfig.maxPlayers;
                    }
                });
            });

            let simplexUnits = {},
                totalPlayersQuantity = 0;
            Object.keys(simplexUnitsGroupedByPositions).map((subPositionName) => {
                for (const positionName of subPositionName.split('/')) {
                    if (!inArray(positionName, usedPositionNames)) {
                        return;
                    }
                }

                simplexUnits = {...simplexUnits, ...simplexUnitsGroupedByPositions[subPositionName]};
            });
            Object.values(positionLimits).map((limit) => (totalPlayersQuantity += limit));

            const ruleBuilder = RuleBuilder.fromAtMost(totalPlayersQuantity, {...simplexUnits});
            result.push(ruleBuilder.createRule());

            return [...result];
        };

        let result = [];
        Object.keys(simplexUnitsByPositionsMatrix).map((key) => {
            result = [
                ...result,
                ...getRuleForMinUnitsQuantity(key, cp(simplexUnitsByPositionsMatrix)),
                ...getRuleForMaxUnitsQuantity(key, cp(simplexUnitsByPositionsMatrix)),
                ...getRuleForMaxMixedUnitsQuantity(key, cp(simplexUnitsByPositionsMatrix)),
            ];
        });

        return [...result];
    }

    positionMaxFromOneTeam({incomingValues = {}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const positions = sportConfig.getConfigProp('positions');
        const players = Object.values(preparedPlayers.groupedBy.playerId());

        const result = [];
        Object.values(positions).map((positionConfig) => {
            if (!positionConfig.maxFromOneTeam) {
                return;
            }

            const teams = {};
            players.map((player) => {
                if (!teams.hasOwnProperty(player.team)) {
                    teams[player.team] = {};
                }

                for (let posNumber of positionConfig.allowedPositions) {
                    if (isPlayerOnDoublePosition(player) || !inArray(posNumber, player.position)) {
                        continue;
                    }

                    teams[player.team][getSimplexUnitName(player.playerId)] = 1;
                }
            });

            Object.values(teams).map((team) => {
                if (!isEmpty(team)) {
                    result.push({
                        row: {...team},
                        obj: positionConfig.maxFromOneTeam,
                        type: Const.STACKS_NUMBER_TYPE_AT_MOST,
                    });
                }
            });
        });

        return [...result];
    }

    subjectToPermanent() {
        const constraints = {
            player: this.exec('player', {}, []),
            salary: this.exec('salary', {}, []),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, []),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {}, []),
            positions: this.exec('positions', {}, []),
            positionMaxFromOneTeam: this.exec('positionMaxFromOneTeam', {}, []),
            games: this.exec('games', {}, []),
            teams: this.exec('team', {}, []),
            limitPositions: this.exec('limitPositions', {}, []),
            projectionBoostRule: this.exec('projectionBoostRule', {}, []),
            limitOnePitcherPerGame: this.exec('limitOnePitcherPerGame', {}, []),
            bound: this.exec('bound', {}, []),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {}, []),
            createdLineups: this.exec('createdLineups', {}, []),
            exposureMax: this.exec('exposureMax', {}, []),
            exposureMin: this.exec('exposureMin', {}, []),
            hitterStacks: this.exec('stackHitters', {}, []),
            nonControlledHittersStacking: this.exec('nonControlledHittersStacking', {}, []),
            teamExposureMax: this.exec(
                'teamExposureMax',
                {
                    minPlayersQuantityToIdentifyUsedTeam: Const.MLB_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM,
                },
                [],
            ),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, []),
        };

        return {...constraints};
    }
}
